import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import ULanding from '../../../../Utils/ULanding';

export default function ModalMenu(props) {
 const token = sessionStorage.getItem('token');
 const mdl = props.data.mdl;
 const id = props.data.id;
 const [data, setData] = useState()
 const [max, setMax] = useState()
 const [Field, setField] = useState({})

 const cek = () => {
  if (id > 0) {
   try {
    ULanding.findMenu(id, token).then((res) => {
     setData(res.data)
     Field['menu'] = res.data.menu;
     Field['link'] = res.data.link;
    })
   } catch (error) {
    console.log(error);
     // props.feedBack({stat: 0, msg: error})
   }
  } else {
   setMax(props.data.max)
  }
 }
 const handleSubmit = (e) => {
  e.preventDefault()
  if (mdl === 'add') {
   Field['urut'] = props.data.max;
   ULanding.addMenu(Field, token).then((res) => {
    props.feedBack(res.data)
   }).catch((error) => {
    props.feedBack({ stat: 0, msg: error })
   })
  } else if (mdl === 'upd') {
   console.log(data);
   Field['id'] = id;
   ULanding.updMenu(Field, token).then((res) => {
    props.feedBack(res.data)
    console.log(res.data);
   }).catch((error) => {
    props.feedBack({ stat: 0, msg: error })
    console.log(error);
   })
  } else if (mdl === 'del') {
   Field['id'] = id;
   ULanding.delMenu(Field, token).then((res) => {
    props.feedBack(res.data)
    console.log(res.data);
   }).catch((error) => {
    props.feedBack({ stat: 0, msg: error })
   })
  }

 }

 const handleChange = async (e) => {
  var target = e.target;
  var name = target.name;
  var value = target.value;
  Field[name] = target.value;
 }

 useEffect(() => {
  cek()
 }, [])

 return (
  <>
   <form onSubmit={handleSubmit}>
    <Modal.Header closeButton>
     <Modal.Title>Modal {mdl}</Modal.Title>
    </Modal.Header>
    {mdl === 'add' || mdl === 'upd' ?
     (
      <>
       <Modal.Body>
        <div class="row">
         <div class="col-sm-6">
          <div class="form-group">
           <label>Menu</label>
           <input type="text" name="menu" defaultValue={data ? data.menu : null} class="form-control" onChange={(e) => handleChange(e)} />
          </div>
         </div>
         <div class="col-sm-6">
          <div class="form-group">
           <label>Link</label>
           <input type="text" name="link" defaultValue={data ? data.link : null} class="form-control" onChange={(e) => handleChange(e)} />
          </div>
         </div>
         <div class="col-sm-6">
          <div class="form-group">
           <label>Urutan</label>
           <input type="text" name="urut" defaultValue={data ? data.urut : max} class="form-control" onChange={(e) => handleChange(e)} />
          </div>
         </div>
        </div>
       </Modal.Body>
      </>
     )
     : (
      <>
       <Modal.Body>
        <div class="col-12">
         <p>Yakin akan delete ?</p>
        </div>
       </Modal.Body>
      </>
     )}
    <Modal.Footer>
     <button type='submit' className='btn bg-info' onClick={(e) => handleSubmit(e)}>
      <i class="fas fa-plus text-white"> Save</i>
     </button>
    </Modal.Footer>
   </form>
  </>
 )
}